
import React from "react";

interface TargetGenerationIndicatorProps {
  targetType?: string;
}

const TargetGenerationIndicator: React.FC<TargetGenerationIndicatorProps> = ({ targetType }) => {
  const getMessage = () => {
    switch (targetType) {
      case 'location':
        return 'Generating your location target...';
      case 'image':
        return 'Generating your image target...';
      case 'random':
        return 'Generating your random target...';
      default:
        return 'Generating your target...';
    }
  };

  return (
    <div className="flex justify-start mb-4">
      <div className="max-w-[80%] p-4 text-base leading-6 break-words bg-card text-card-foreground rounded-2xl border">
        <div className="flex items-center space-x-3">
          <div className="flex space-x-1">
            <div 
              className="w-2 h-2 bg-primary rounded-full animate-pulse"
              style={{
                animationDelay: '0ms',
                animationDuration: '1.4s'
              }}
            />
            <div 
              className="w-2 h-2 bg-primary rounded-full animate-pulse"
              style={{
                animationDelay: '200ms',
                animationDuration: '1.4s'
              }}
            />
            <div 
              className="w-2 h-2 bg-primary rounded-full animate-pulse"
              style={{
                animationDelay: '400ms',
                animationDuration: '1.4s'
              }}
            />
          </div>
          <span className="text-primary font-medium">{getMessage()}</span>
        </div>
      </div>
    </div>
  );
};

export default TargetGenerationIndicator;
